/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="10"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Logout Logs</h1></div>
        <div class="header-sub-title">Get the user force logout records</div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="1-4"/>
      <div class="content">
        <div>
          <div class="tool-bar row">
            <div class="col">
              <div class="icon-group right-float-element">
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="UserName"
                          v-model="listParam.UserName"/>
                <el-select style="max-width: 160px" class="mr-1" @change="selectPage(1)" clearable placeholder="User Type"
                           v-model="listParam.RoleName">
                  <el-option v-for="role in roles" :key="role.id" :label="role.name" :value="role.name"/>
                </el-select>
                <el-input style="max-width: 160px" class="mr-1" @input="search()" clearable placeholder="Reason"
                          v-model="listParam.Reason"/>
                <el-date-picker
                    style="width: 260px"
                    type="daterange"
                    v-model="dateValue"
                    start-placeholder="Start Date"
                    popper-class="date-range-picker-popper"
                    value-format="yyyy-MM-dd"
                    format="dd/MM/yyyy"
                    @change="changeDates"
                    end-placeholder="End Date"
                    clearable
                />
              </div>
            </div>
          </div>
          <div class="content-scroll-x">
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:8%" class="long-text">ID</th>
                  <th style="width:22%" class="long-text">User Name</th>
                  <th style="width:18%" class="long-text">User Type</th>
                  <th style="width:30%" class="long-text">Reason</th>
                  <th style="width:22%; vertical-align:middle" class="icon-col">Log Date</th>
                </tr>
                </thead>
              </table>
            </div>
            <div class="content-scroll-y">
              <table class="table">
                <tbody>
                <tr v-for="(log, index) in logs" :key="index" >
                  <td style="width:8%" class="long-text">
                    {{ getLogId(log) }}
                  </td>
                  <td style="width:22%" class="long-text">
                    <el-tooltip effect="dark" :content="log.UserName">
                      <span>{{ decodeURIComponent(log.UserName) }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:18%" class="long-text">
                    <el-tooltip effect="dark" :content="log.RoleName">
                      <span>{{ log.RoleName }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:30%" class="long-text">
                    <el-tooltip effect="dark" :content="log.Reason">
                      <span>{{ log.Reason }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:22%;vertical-align:middle" class="icon-col">
                    {{ getTime(log.LogoutTime) }}
                  </td>
                </tr>
                <tr v-if="logs.length === 0">
                  <td colspan="5">No results to display.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import { debounce } from 'lodash';
import Header from '@/components/Header'

export default {
  name: 'AdminLogoutLog',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    return {
      dateValue: [],
      logs: [],
      roles: [],
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        UserName: '',
        RoleName: '',
        Reason: '',
        LogoutTimeStart : null,
        LogoutTimeEnd: null,
        orderBy: 'id',
        order: 'DESC',
      },
    }
  },
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    changeDates(v) {
      if (v) {
        // Selected dates are local calendar days; attach local start/end time, then convert to UTC.
        this.listParam.LogoutTimeStart = moment(v[0] + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss')
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
        this.listParam.LogoutTimeEnd = moment(v[1] + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss')
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.listParam.LogoutTimeStart = null
        this.listParam.LogoutTimeEnd = null
      }
      this.selectPage(1)
    },
    getLogId(log) {
      return log.id || log.ID || log.LogoutRecordID
    },
    getLogTimestamp(log) {
      const value = log.LogoutTime || log.CreatedAt || log.LogDate || log.LogoutDate
      if (!value) {
        return 0
      }
      const time = moment.utc(value).local().valueOf()
      return Number.isNaN(time) ? 0 : time
    },
    getTime(item) {
      if (!item) {
        return ''
      }
      return moment.utc(item).local().format('DD/MM/YYYY HH:mm:ss')
    },
    sortLogs(logs) {
      return (logs || []).slice().sort((a, b) => {
        const idDiff = Number(this.getLogId(b) || 0) - Number(this.getLogId(a) || 0)
        if (idDiff !== 0) {
          return idDiff
        }
        return this.getLogTimestamp(b) - this.getLogTimestamp(a)
      })
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    async loadData() {
      this.$store.dispatch("loading/setLoadComponent", true)
      let param = {}
      for (let i in this.listParam) {
        if (this.listParam[i] !== undefined && this.listParam[i] !== null && this.listParam[i] !== "") param[i] = this.listParam[i]
      }
      const {data, count} = await utilities.getUserLogoutRecords(param)
      this.logs = this.sortLogs(data || [])
      this.totalCount = count || 0
      this.$store.dispatch("loading/setLoadComponent", false)
    },
  },
  async beforeMount() {
    this.roles = (await utilities.getUserRoles()) || []
    await this.loadData()
  },
}
</script>
